import { render, staticRenderFns } from "./ArmyDetail.vue?vue&type=template&id=2c79f916&scoped=true&"
import script from "./ArmyDetail.vue?vue&type=script&lang=js&"
export * from "./ArmyDetail.vue?vue&type=script&lang=js&"
import style0 from "./ArmyDetail.vue?vue&type=style&index=0&id=2c79f916&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c79f916",
  null
  
)

export default component.exports